module.exports = __webpack_public_path__ + "img/android-home-01.065ca5d9.jpg";